import React, { useState } from "react";

import * as H from "./heroSectionElement";

import img from "assets/img1.jpg";
import profileImg from "assets/profileImg.jpg";
import check from "../../assets/check.png";
import video from "../../assets/video.png";
import { FiInfo } from "react-icons/fi";

import * as C from "components/common";
import headerimg from "../../assets/headerimg.png";

interface Props {
  cardProfileInfoImg?: string;
  className?: string;
  cardProfileInfoImg1?: string;
  item: any;
  heroCard?: any;
  heroCardImg?: any;
  explore?: boolean;
  create?: boolean;
}

const HeroCardSlider: React.FC<Props> = ({ item }) => {
  const [hover, setHover] = useState(false);

  const handleMouseOver = () => {
    setHover(true);
  };

  const handleMouseOut = () => {
    setHover(false);
  };
  return (
    <div>
      <C.MainRow>
        <C.MainCol lg={6}>
          <H.LeftWrapper>
            <H.HeroTitle>
              {item?.title}
              <img className="img-fluid" alt="" src={check} />
            </H.HeroTitle>
            <H.HeroDesc>{item?.description}</H.HeroDesc>
            <H.MainButtonDiv>
              <C.Buttons explore>Explore</C.Buttons>
              <C.Buttons
                create
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
              >
                Learn More
                {hover && <img className="img-fluid" alt="" src={video} />}
              </C.Buttons>
            </H.MainButtonDiv>
          </H.LeftWrapper>
        </C.MainCol>
        <C.MainCol lg={6}>
          <C.MainCard heroCard>
            <C.CardImg src={headerimg} heroCardImg />
            <C.CardBody>
              <C.MainRow>
                <C.MainCol lg={6} xs={6}>
                  <C.CardMain>
                    <C.CardText>{item?.cardTitle}</C.CardText>
                  </C.CardMain>
                </C.MainCol>
                <C.MainCol lg={6} xs={6}>
                  <C.CardInfoIconMain>
                    <FiInfo
                      style={{
                        color: "#000000",
                        transform: "translate(-20px, -8px)",
                        cursor: "pointer",
                      }}
                    />
                  </C.CardInfoIconMain>
                </C.MainCol>
              </C.MainRow>
            </C.CardBody>
          </C.MainCard>
        </C.MainCol>
      </C.MainRow>
    </div>
  );
};

export default HeroCardSlider;
